import type { ComponentType } from "react";
import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { Abo } from "./Abo";
import { Branding, Mailversand, Region } from "./Branding";
import { Einrichtung, EinrichtungStart } from "./Einrichtung";
import { Export } from "./Export";
import { Firma } from "./Firma";
import { Konditionen } from "./Konditionen";
import { Mahnleiter } from "./Mahnleiter";
import { Passwort } from "./Passwort";
import { AnmeldungSicherheit, Profil } from "./Profil";
import { Registrieren } from "./Registrieren";
import { Team } from "./Team";
import { Vorlagen } from "./Vorlagen";
import { Whatsapp } from "./Whatsapp";
import { AlleEinstellungen } from "./Uebersicht";
import { Rollen } from "./Rollen";
import { PdfVorlagen } from "./PdfVorlagen";
import { PdfVorlageEditor } from "./PdfVorlagenEditor";
import {
  Abrechnungsweg, AnfragenEinstellung, CreatorSichtSeite, Gutschriften, HerkunftSeite, KooperationenEinstellung, MarkenFreigabe, ModuleUebersicht,
  Nummernkreise, Plattformen, Positionsarten, Provision, Pruefregeln, Recht, Staffel, Verguetung, Wiedervorlagen, Zahlungsziele,
} from "./Seiten";
import { PROFIL_WEG, UNBEKANNT_ZIEL, type SeiteKey } from "./baum";

/**
 * Seiten von „Alle Einstellungen“ (IA-1) je Schlüssel aus baum.ts. Der Test einstellungen-wege prüft, dass jede Seite des
 * Baums hier steht und jeder Verweis im Code ein Ziel hat.
 */
export const EINSTELLUNG_SEITEN: Record<SeiteKey, ComponentType> = {
  firma: Firma, branding: Branding, region: Region, team: Team, rollen: Rollen, recht: Recht,
  provision: Provision, abrechnungsweg: Abrechnungsweg, zahlungsziele: Zahlungsziele, pruefregeln: Pruefregeln, wiedervorlagen: Wiedervorlagen,
  staffel: Staffel, "herkunft-nachprovision": HerkunftSeite, gutschriften: Gutschriften, mahnleiter: Mahnleiter,
  nummernkreise: Nummernkreise, positionsarten: Positionsarten, plattformen: Plattformen, verguetung: Verguetung, "pdf-vorlagen": PdfVorlagen, vorlagen: Vorlagen,
  kooperationen: KooperationenEinstellung, "marken-freigabe": MarkenFreigabe, anfragen: AnfragenEinstellung, "creator-sicht": CreatorSichtSeite, module: ModuleUebersicht,
  mailversand: Mailversand, export: Export, whatsapp: Whatsapp,
  abo: Abo,
};

/** Einstellungen der Agentur (nur Admins; Manager sehen „nicht freigegeben“) und das eigene Profil, im Agentur-Rahmen. */
export const einstellungenRoutes: RouteObject[] = [
  // IA-1: Startseite „Alle Einstellungen“ auf jeder Breite (vorher am Desktop direkt die erste Seite)
  { path: "einstellungen", element: <AlleEinstellungen /> },
  ...Object.entries(EINSTELLUNG_SEITEN).map(([key, Seite]) => ({ path: `einstellungen/${key}`, element: <Seite /> })),
  // Alte Wege: Konditionen leitet je Anker auf die neue Seite, sonst zur Gruppe Geld & Abrechnung
  // PDF-Vorlagen (0456): Editor je Vorlage („neu?art=invoice“ legt eine an)
  { path: "einstellungen/pdf-vorlagen/:vorlageId", element: <PdfVorlageEditor /> },
  { path: "einstellungen/konditionen", element: <Konditionen /> },
  // K-372: Anmeldung & Sicherheit (Passwort, Adresse, zweiter Faktor, Sitzungen) aus dem Profil, für jede Person
  { path: "einstellungen/sicherheit", element: <AnmeldungSicherheit /> },
  { path: "einstellungen/profil", element: <Navigate to={PROFIL_WEG} replace /> },
  { path: "einstellungen/:bereich", element: <Navigate to={UNBEKANNT_ZIEL} replace /> },
  { path: "profil", element: <Profil /> },
];

/** Eigenständige Wege außerhalb des Agentur-Rahmens: Einrichtung einer neuen Agentur, Konto anlegen, Passwort. */
export const einrichtungRoutes: RouteObject[] = [
  { path: "/einrichtung", element: <EinrichtungStart /> },
  { path: "/einrichtung/:schritt", element: <Einrichtung /> },
  { path: "/registrieren", element: <Registrieren /> },
  { path: "/passwort", element: <Passwort /> },
];
